export const config = {
  apiUrl: import.meta.env.VITE_API_URL as string,
  userPoolId: import.meta.env.VITE_USER_POOL_ID as string,
  userPoolClientId: import.meta.env.VITE_USER_POOL_CLIENT_ID as string,
  region: import.meta.env.VITE_REGION as string,
};

for (const [k, v] of Object.entries(config)) {
  if (!v) throw new Error(`Missing env: VITE_${k.replace(/[A-Z]/g, m => "_" + m).toUpperCase()}`);
}
